module.exports = {
  message: {
    service_desc: 'Use the utility to swap COS between different token formats including <strong>MainNet Native COS, ERC-20, and BEP-20.</strong>',
    choose_token_type: 'Token swap direction',
    fee_tips: '',
    token_type_erc20_to_bep2: 'ERC-20 => BEP2',
    token_type_erc20_to_native: 'ERC-20 => MainNet Native COS',
    token_type_bep2_to_erc20: 'BEP2 => ERC-20',
    token_type_bep2_to_native: 'BEP2 => MainNet Native COS',
    token_type_native_to_erc20: 'MainNet Native COS => ERC-20',
    token_type_native_to_bep2: 'MainNet Native COS => BEP2',
    token_type_bep20_to_native: 'BEP-20 => MainNet Native COS',
    token_type_native_to_bep20: 'MainNet Native COS => BEP-20',
    enter_address: 'Token swap destination account / address',
    enter_exchange_memo: 'Memo (The destination address appears to be an exchange. Please specify memo to receive COS correctly)',
    create_account_tips: 'Don\'t have an account? Create one!',
    next_btn: 'NEXT',
    start_over_btn: 'Start over',
    ready_to_swap: 'READY TO SWAP',
    transfer_prefix: 'Transfer your {token} to',
    address: 'ACCOUNT / ADDRESS',
    memo: 'MEMO',
    auto_swap_desc_memo: 'Make sure you enter the ACCOUNT / ADDRESS and MEMO correctly. Swap token utility will send out the corresponding amount of COS token to the below wallet once receiving your token. <strong>The process may take about 5-30 minutes<strong>.',
    auto_swap_desc: 'Make sure you enter the ACCOUNT / ADDRESS correctly. Swap token utility will send out the corresponding amount of COS token to the below wallet once receiving your token. <strong>The process may take about 5-30 minutes<strong>.',
    main_net_address: 'Contentos MainNet Account',
    bep2_address: 'BEP2 Address',
    erc20_address: 'ERC-20 Address',
    bep20_address: 'BEP-20 Address',
    main_net_token: 'COS MainNet',
    bep2_token: 'BEP2 COS',
    erc20_token: 'ERC-20 COS',
    bep20_token: 'BEP-20 COS',
    ok: 'OK',
    Cancel: 'Cancel',
    tips: 'Tips',
    enter_address_tips: 'Please fill in the correct address',
    enter_exChange_memo_tips: 'Please fill in the exchange memo',
    swap_address_invalid: 'Invalid address',
    swap_address_not_exit: 'The account does not exist',
    swap_type_invalid: 'Invalid token swap direction',
    swap_system_error: 'System error occurred. Please try again later.',
    swap_unknown_error: 'Unknown error occurred. Please try again later.',
    swap_memo_invalid: 'Invalid Memo',
    invalid_bnb_exChange_memo_tips: 'Binance exchange memo should be a number',
    service_not_available_title: 'Service temporarily unavailable',
    service_not_available_message: 'An unsuccessful token swap was detected in the past 20 minutes. We will resume the service as soon as the problem is resolved. We appreciate your understanding. YOUR FUND IS SAFE.',
    paste_warning: 'Please check the address and ensure that it is identical to the one above when copying and pasting on an exchange.',
    fee_notice: 'Notice: A service fee of {fee} COS will be deducted for each swap to cover the gas fees for {token} transfers among accounts. Swap requests for amounts less than {fee} COS will not be processed.',
    fee_subject_to_change: 'The service fee is subject to change without prior notice',
    view_status: 'View conversion status',
    prev_step: 'Back',
    go_back: 'Back',
    transfer_prefix_before: 'Transfer your',
    transfer_prefix_after: 'to',
    copy_memo: 'Copy MEMO',
    copy_address: 'Copy address',
    copy_success: 'Copied',
    memo_warning: 'Important: Please attach the correct MEMO when transferring. The system will convert the actual deposited amount and send it back to the address you provided. Do not omit the MEMO.',
    col_time: 'Time',
    col_target_format: 'Target format',
    col_target_account: 'Target account',
    col_amount: 'Amount',
    col_status: 'Status',
    loading: 'Loading\u2026',
    no_data: 'No data',
    next_update_hint: 'Data will refresh in {time}',
    status_done: 'Completed',
    status_pending: 'Pending',
    panel_title_status: 'Conversion Status',
    panel_title_step1: 'Token Conversion Tool',
    panel_title_step2: 'Ready to Convert Tokens',
    panel_subtitle_status: 'Select source token format to check the conversion records',
    source_network: 'Source token format',
    conversion_record: 'Conversion Records',
    new_label: 'New'
  }
}
